(function () {
  'use strict';

  /* ============================================
     Mobile: Multi-panel drawer navigation
     ============================================ */

  function initMobilePanels() {
    var outer = document.querySelector('.wfs-panels-outer');
    var track = document.querySelector('.wfs-panels-track');
    if (!outer || !track) return;

    var currentIndex = 0;
    var animating = false;

    function goTo(targetIndex) {
      if (targetIndex === currentIndex || animating) return;
      animating = true;
      currentIndex = targetIndex;

      track.classList.add('wfs-is-animating');
      track.style.transform = 'translateX(-' + (targetIndex * 50) + '%)';

      setTimeout(function () {
        track.classList.remove('wfs-is-animating');
        animating = false;
      }, 340);
    }

    function resetPanels() {
      currentIndex = 0;
      animating = false;
      track.classList.remove('wfs-is-animating');
      track.style.transition = 'none';
      track.style.transform = 'translateX(0)';
      requestAnimationFrame(function () {
        track.style.transition = '';
      });
    }

    /* Panel navigation */
    track.addEventListener('click', function (e) {
      var fwd = e.target.closest('[data-wfs-panel-go]');
      if (fwd) { e.preventDefault(); goTo(parseInt(fwd.getAttribute('data-wfs-panel-go'), 10)); return; }

      var back = e.target.closest('[data-wfs-panel-back]');
      if (back) { e.preventDefault(); goTo(parseInt(back.getAttribute('data-wfs-panel-back'), 10)); return; }
    });

    /* Fix close buttons in panels 2+ */
    var navDrawer = document.getElementById('NavDrawer');
    if (navDrawer) {
      navDrawer.querySelectorAll('.js-drawer-close').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var primary = navDrawer.querySelector('#wfs-panel-1 .js-drawer-close');
          if (primary && btn !== primary) primary.click();
          resetPanels();
        });
      });
    }

    /* Reset on drawer open */
    document.querySelectorAll('.js-drawer-open-nav').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(resetPanels, 20);
      });
    });

    document.addEventListener('drawerOpen', function () {
      var nd = document.getElementById('NavDrawer');
      if (nd && nd.classList.contains('drawer--is-open')) resetPanels();
    });
  }

  /* ============================================
     Accordion — ODZIEŻ subcategories
     ============================================ */

  function initAccordion() {
    document.querySelectorAll('.wfs-accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var accordion = trigger.closest('.wfs-accordion');
        if (!accordion) return;
        accordion.classList.toggle('wfs-accordion--open');
      });
    });
  }

  /* ============================================
     Init
     ============================================ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMobilePanels();
      initAccordion();
    });
  } else {
    initMobilePanels();
    initAccordion();
  }

})();